<iframe
  *ngIf="trustedSrc"
  [id]="iframeId"
  [src]="trustedSrc"
  [style.height.px]="heightPx"
  class="form-map-iframe"
  frameborder="0"
  scrolling="no"
  allowfullscreen
  allow="geolocation"
></iframe>
